import PageHero from "../components/PageHero";

function She4SeaProfilingTool() {
  return (
    <>
      <PageHero
        eyebrow="She4Sea"
        title="She4sea Profiling Tool"
        text="A self-assessment tool helping women explore their skills, strengths and career potential in the blue economy."
      />

      <section className="section profiling-tool-section">
        <div className="profiling-tool-card">
          <div className="profiling-tool-image">
            <img
              src="/images/news/she4sea/profiling-tool/she4sea-profiling-tool.jpg"
              alt="She4Sea Profiling Tool"
            />
          </div>

          <div className="profiling-tool-content">
            <span className="eyebrow">Online Tool</span>

            <h2>Mapping skills into blue economy career pathways</h2>

            <p>
              The She4Sea Digital Profiling Tool helps women map their competencies
              and career potential in maritime sectors. Users self-assess their
              skills in Leadership, Entrepreneurship, and Sustainability and receive
              guidance on learning pathways that fit their profile.
            </p>

            <p>
              The tool works through a focused questionnaire covering both soft
              skills and hard skills. Users reflect on the abilities they already
              have, the areas where they feel confident, and the fields where they
              may need further development.
            </p>

            <p>
              Based on the user’s answers, the tool calculates a personalised
              profile and suggests possible career directions in the maritime,
              aquaculture, and tourism sectors. In this way, it connects individual
              strengths with real opportunities in the blue economy.
            </p>

            <p>
              Now available online — fast, free, and insightful.
            </p>

            <h3>Training Tailored for the Blue Economy: She4Sea Online Platform</h3>

            <p>
              Together with the She4Sea training platform, the profiling tool
              supports women in understanding their potential, choosing relevant
              learning paths, and taking more confident steps toward blue economy
              careers.
            </p>

            <div className="profiling-tool-actions">
              <a
                href="https://she4seaproject.eu"
                target="_blank"
                rel="noreferrer"
                className="btn secondary"
              >
                Visit the project website
              </a>

              <a
                href="https://she4seaproject.eu/profiling-tool"
                target="_blank"
                rel="noreferrer"
                className="btn primary"
              >
                Visit the profiling tool
              </a>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default She4SeaProfilingTool;